export default __webpack_public_path__ + "static/SharpSansNo1-Bold-b10b9a7be9ea73de1398b35efeb36c2a.ttf";